<template>
  <div class="flex items-center justify-center">
    <div
      :class="['rounded-none overflow-hidden flex items-center justify-center border border-8', frameBorderClass]"
      :style="{ width: `${width}px`, height: `${height}px` }"
      role="img"
      :aria-label="tag?.title || 'path tag'"
    >
      <img
        v-if="tag?.icon"
        :src="rpAPI.getAssetUrl(tag.icon, '.webp')"
        :alt="tag?.title || 'tag'"
        class="w-full h-full object-cover"
      />
      <div
        v-else
        class="bg-white text-center p-2 text-lg sm:text-xl font-bold flex items-center justify-center w-full h-full"
      >
        {{ tag?.title }}
      </div>
    </div>
  </div>
</template>

<script setup>
import rpAPI from '@shared/service/rpAPI.js';

defineProps({
  tag: {
    type: Object,
    default: () => ({ title: '', icon: null }),
  },
  // pass a border color utility, e.g. "border-primary-500"
  frameBorderClass: {
    type: String,
    default: 'border-primary-500',
  },
  width: {
    type: Number,
    default: 120,
  },
  height: {
    type: Number,
    default: 140,
  },
});
</script>